"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GameResults = exports.GameResultsProperties = void 0;
var enums_1 = require("./enums");
var game_slide_answer_1 = require("./game-slide-answer");
function uniqueFilter(value, index, self) {
  return self.indexOf(value) === index;
}
exports.GameResultsProperties = ['id', 'user_id', 'lesson_id', 'created_at', 'started_at', 'finished_at', 'slides_count', 'index', 'grade', 'total_max_points'];
var GameResults = /** @class */function () {
  function GameResults(values) {
    if (values === void 0) {
      values = {};
    }
    /** Ответы на слайды */
    this.answers = [];
    var properties = exports.GameResultsProperties;
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.answers = (values.answers || []).map(function (a) {
      return new game_slide_answer_1.GameSlideAnswer(a);
    });
  }
  Object.defineProperty(GameResults.prototype, "maxPoints", {
    get: function () {
      return this.total_max_points;
      // return this.answers.reduce((sum: number, answer: GameSlideAnswer) => (sum + answer.max_points), 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameResults.prototype, "totalPoints", {
    get: function () {
      return this.answers.reduce(function (sum, answer) {
        return sum + answer.total_points;
      }, 0);
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameResults.prototype, "percent", {
    /**
     * Результат выполнения заданий исходя из баллов за ответы (0...100)
     */
    get: function () {
      var _a = this,
        maxPoints = _a.maxPoints,
        totalPoints = _a.totalPoints;
      return maxPoints > 0 ? Math.round(totalPoints / maxPoints * 100) : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameResults.prototype, "passProgress", {
    /**
     * Прогресс выполнения заданий исходя из количество слайдов, на которые есть правильные или неправильные ответы (0...100)
     */
    get: function () {
      var _a = this,
        passedCount = _a.passedCount,
        slides_count = _a.slides_count;
      return slides_count > 0 ? Math.round(passedCount / slides_count * 100) : 0;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameResults.prototype, "passedCount", {
    get: function () {
      return this.answers.filter(function (a) {
        return a.is_answered;
      }) // отвеченные
      .map(function (a) {
        return a.slide_id;
      }) // номер слайда
      .filter(uniqueFilter).length; // уникальные номера слайдов
    },
    enumerable: false,
    configurable: true
  });
  GameResults.getGradeABC = function (percent) {
    var _a;
    var grade = GameResults.percentToGrageABC(percent);
    var symbols = (_a = {}, _a[enums_1.GameGradeABCEnum.markAplus] = 'A+', _a[enums_1.GameGradeABCEnum.markA] = 'A', _a[enums_1.GameGradeABCEnum.markAminus] = 'A-', _a[enums_1.GameGradeABCEnum.markBplus] = 'B+', _a[enums_1.GameGradeABCEnum.markB] = 'B', _a[enums_1.GameGradeABCEnum.markBminus] = 'B-', _a[enums_1.GameGradeABCEnum.markCplus] = 'C+', _a[enums_1.GameGradeABCEnum.markC] = 'C', _a[enums_1.GameGradeABCEnum.markCminus] = 'C-', _a[enums_1.GameGradeABCEnum.markDplus] = 'D+', _a[enums_1.GameGradeABCEnum.markD] = 'D', _a[enums_1.GameGradeABCEnum.markDminus] = 'D-', _a[enums_1.GameGradeABCEnum.markF] = 'F', _a);
    return symbols[grade] || '?';
  };
  GameResults.getGrade543 = function (percent) {
    var _a;
    var grade = GameResults.percentToGrade543(percent);
    var symbols = (_a = {}, _a[enums_1.GameGrade543Enum.mark5plus] = '5+', _a[enums_1.GameGrade543Enum.mark5] = '5', _a[enums_1.GameGrade543Enum.mark4Plus] = '4+', _a[enums_1.GameGrade543Enum.mark4] = '4', _a[enums_1.GameGrade543Enum.mark3] = '3', _a[enums_1.GameGrade543Enum.mark2] = '2', _a[enums_1.GameGrade543Enum.mark1] = '1', _a);
    return symbols[grade] || '?';
  };
  /**
   *
   * @param percent
   */
  GameResults.percentToGrade543 = function (percent) {
    /**
     * Lingo1
     * if ($gradePercent == 100) $mark = '5-plus';
     * if ($gradePercent < 100) $mark = '5';
     * if ($gradePercent < 91) $mark = '4-plus';
     * if ($gradePercent < 86) $mark = '4';
     * if ($gradePercent < 81) $mark = '3';
     * if ($gradePercent < 71) $mark = '2';
     * if ($gradePercent < 61) $mark = '1';
     */
    var ranges = [[enums_1.GameGrade543Enum.mark5plus, 100, 100], [enums_1.GameGrade543Enum.mark5, 91, 99], [enums_1.GameGrade543Enum.mark4Plus, 86, 90], [enums_1.GameGrade543Enum.mark4, 81, 85], [enums_1.GameGrade543Enum.mark3, 71, 80], [enums_1.GameGrade543Enum.mark2, 61, 70], [enums_1.GameGrade543Enum.mark1, 0, 60]];
    var range = ranges.filter(function (_a) {
      var grage = _a[0],
        min = _a[1],
        max = _a[2];
      return percent >= min && percent <= max;
    }).pop();
    return range[0];
  };
  GameResults.percentToGrageABC = function (percent) {
    percent = percent || 0;
    /** @see https://en.wikipedia.org/wiki/Academic_grading_in_the_United_States */
    var ranges = [[enums_1.GameGradeABCEnum.markAplus, 97, 100], [enums_1.GameGradeABCEnum.markA, 93, 96], [enums_1.GameGradeABCEnum.markAminus, 90, 92], [enums_1.GameGradeABCEnum.markBplus, 87, 89], [enums_1.GameGradeABCEnum.markB, 83, 86], [enums_1.GameGradeABCEnum.markBminus, 80, 82], [enums_1.GameGradeABCEnum.markCplus, 77, 79], [enums_1.GameGradeABCEnum.markC, 73, 76], [enums_1.GameGradeABCEnum.markCminus, 70, 72], [enums_1.GameGradeABCEnum.markDplus, 67, 69], [enums_1.GameGradeABCEnum.markD, 63, 66], [enums_1.GameGradeABCEnum.markDminus, 60, 62], [enums_1.GameGradeABCEnum.markF, 0, 59]];
    var range = ranges.filter(function (_a) {
      var grage = _a[0],
        min = _a[1],
        max = _a[2];
      return percent >= min && percent <= max;
    }).pop();
    return range[0];
  };
  Object.defineProperty(GameResults.prototype, "isStarted", {
    get: function () {
      return !!this.started_at;
    },
    enumerable: false,
    configurable: true
  });
  Object.defineProperty(GameResults.prototype, "isFinished", {
    get: function () {
      return !!this.finished_at;
    },
    enumerable: false,
    configurable: true
  });
  return GameResults;
}();
exports.GameResults = GameResults;
